import React from "react";
import Logo from "shared/Logo/Logo";
import Navigation from "shared/Navigation/Navigation";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import MenuBar from "shared/MenuBar/MenuBar";
import SwitchDarkMode from "shared/SwitchDarkMode/SwitchDarkMode";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { UserCircleIcon } from "@heroicons/react/24/solid";

const MainNav1 = ({ className = "" }) => {
  const isLoggedIn = useSelector((state) => state?.auth?.jwt);
  return (
    <div className={`nc-MainNav1 relative z-10 ${className}`}>
      <div className="px-4 lg:container py-4 lg:py-5 relative flex justify-between items-center">
        <div className="hidden md:flex justify-start flex-1 items-center space-x-4 sm:space-x-10">
          <Logo />
          <Navigation />
        </div>

        <div className="lg:hidden flex-[3] max-w-lg !mx-auto md:px-3">
          {/* Mobile Search  */}
          {/* <HeroSearchForm2MobileFactory /> */}
        </div>

        <div className="hidden md:flex flex-shrink-0 items-center justify-end flex-1 lg:flex-none text-neutral-700 dark:text-neutral-100">
          <div className="hidden xl:flex items-center space-x-0.5">
            <SwitchDarkMode />
            {/* <SearchDropdown /> */}
            <div className="px-1" />
            {!isLoggedIn ? (
              <ButtonPrimary href="/login">Login/Signup</ButtonPrimary>
            ) : (
              <Link
                key="1"
                to="/account"
                className={`flex flex-col items-center justify-between text-neutral-500 dark:text-neutral-300/90`}
              >
                <UserCircleIcon className={`w-6 h-6 `} />
                <span className="text-[11px] leading-none mt-1">Account</span>
              </Link>
            )}
          </div>
          <div className="flex xl:hidden items-center">
            <SwitchDarkMode />
            <div className="px-0.5" />
            {/* <MenuBar /> */}
            {!isLoggedIn ? (
              <ButtonPrimary href="/login">Login/Signup</ButtonPrimary>
            ) : (
              <Link
                key="1"
                to="/account"
                className={`flex flex-col items-center justify-between text-neutral-500 dark:text-neutral-300/90`}
              >
                <UserCircleIcon className={`w-6 h-6 `} />
                <span className="text-[11px] leading-none mt-1">Account</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav1;
